export default "__VITE_ASSET__BjTm827s__"